module.exports = __webpack_public_path__ + "static/media/login_background.66eaf44d.jpg";